import { Component, ViewChild } from '@angular/core';
import { NgClass, AsyncPipe, CommonModule } from '@angular/common';
import { CrudService } from 'src/app/services/crud.service';
import { environment } from 'src/environments/environment';
import { CostServiceService } from 'src/app/services/cost-service.service';
import { HorizontalMenuService } from 'src/app/services/horizontalmenu.service';
import { PromotionDetailsGroup } from '../models/promotion-details-group.model';
import { Product } from '../models/product.model';
import { RebateNames } from '../models/rebate-names.model';
import { DxDataGridComponent, DxDataGridModule, DxPopupComponent, DxTooltipComponent, 
  DxButtonModule, DxTooltipModule, DxPopupModule, 
  DxLoadPanelModule} from 'devextreme-angular';
import { lastValueFrom, Observable, map } from 'rxjs';
import { tap } from 'rxjs/operators';
import { NotifyService } from '../services/notify.service';
import { Router } from '@angular/router';
import { on } from 'devextreme/events';
import { confirm } from 'devextreme/ui/dialog';
import { PromotionRebatesComponent } from '../settings/promotion-rebates/promotion-rebates.component';
import { ByGroupDetailsComponent } from '../by-group-details/by-group-details.component';
import { PromotionGroupSelectionComponent } from '../promotion-group-selection/promotion-group-selection.component';
import { ConfirmationService } from '../services/confirmation.service';
import { AiIntegrationService } from '../services/ai-integration.service';
import { AIAssistant } from 'devextreme/ui/data_grid';
import { PageHeaderComponent } from 'src/app/shared/page-header/page-header.component';


@Component({
    selector: 'app-promotion-details-by-group',
    templateUrl: './promotion-details-by-group.component.html',
    styleUrls: ['./promotion-details-by-group.component.css'],
    imports: [ CommonModule, NgClass, AsyncPipe,
      DxDataGridModule, DxButtonModule, DxTooltipModule, DxPopupModule, DxLoadPanelModule,
      PromotionRebatesComponent, ByGroupDetailsComponent, PromotionGroupSelectionComponent, PageHeaderComponent ],
    standalone: true
})
export class PromotionDetailsByGroupComponent {

  data$: Observable<string[]>;
  currencyFormat = { type: 'currency', precision: 2 };
  rebateNames: RebateNames[];
  columns: any[] = [];
  header: any;
  promoType:string = '';
  detailsLoading: boolean = true;
  allowEditing: boolean = true;
  disabled: boolean = false;
  tooltipData: any;
  tooltipTarget: string = '';
  storageKey: string = 'promotionDetailsGroupsState';
  percentageFormat = { type: 'fixedPoint', precision: 2 };
  isBuilt: boolean = false;
  masterDetailEditing: boolean = false;
  swappingPromotionGroup: boolean = false;
  permissions: boolean = true; //Change this logic for when there is permissions on user details for admin users etc.
  aiAssistant: AIAssistant;
  private apiUrl: string = environment.baseApiUrl;
  @ViewChild(DxDataGridComponent, { static: false }) public dataGrid: DxDataGridComponent;
  @ViewChild('promotionGroupSelection', {static: false}) promotionGroupSelection: DxPopupComponent;
  @ViewChild(DxTooltipComponent) tooltip: DxTooltipComponent;

  constructor(private crudService: CrudService,
    private costService: CostServiceService,
    private horizontalMenuService: HorizontalMenuService,
    private notifyService: NotifyService,
    private router: Router,
    private confirmationService: ConfirmationService,
    aiIntegrationService: AiIntegrationService) {
    this.aiAssistant = {
      enabled: true,
      aiIntegration: aiIntegrationService.integration,
      title: 'Promotion Assistant'
    };
    const state = this.router.getCurrentNavigation()?.extras.state;
    if (state) {
      this.header = state['header'];
    }
    this.loadData();
    this.addColumn();
    let promotionLocked: string = '';
      if(this.header.status_type === 'closed') {
        this.allowEditing = false;
        this.disabled = true;
        promotionLocked = ' - *** Promotion Locked  - View Only Mode***';
      }
    this.promoType = `${this.header.promotion_name} - ${this.header.description} | Details: ${this.header.promotion_start} - ${this.header.promotion_end}${promotionLocked}`;
  }

  loadState = () =>
    {
      setTimeout(() => {
        console.log('loading state');
        if (localStorage.getItem(this.storageKey) !== null) {
          const state = JSON.parse(localStorage.getItem(this.storageKey) || '');
          this.dataGrid.instance.state(state);
          return state;
        }
      }, 300);
    }
  
    saveState = (state: any) => {
      if(!this.detailsLoading) {
        setTimeout(() => {
          console.log('SaveState');
          //const state = this.dataGrid.instance.state();
          localStorage.setItem(this.storageKey, JSON.stringify(state));
        }, 300);
      }
    }

  loadData() {
    if(this.swappingPromotionGroup !== true) {
      this.detailsLoading = true;
      this.data$ = this.crudService.newGetData(`${this.apiUrl}promotion-details-groups?promotion_header_id=${this.header.id}`).pipe(
        tap((result: any) => {
          this.detailsLoading = false;
        })
      );
    }
  }

  resetGridState() {
    confirm('Are you sure you want to reset the grid to default?', 'Reset to default').then((result) => {
      if(result) {
        localStorage.removeItem('promotionDetailsGroupsState');
        this.dataGrid.instance.state(null); // Reset the grid state
        this.dataGrid.instance.refresh(); // Refresh the grid
      }
    });
  }

  async rowRemoving(e: any) {
    await lastValueFrom(this.crudService.deleteData(`${this.apiUrl}promotion-details-groups`, e.key).pipe(
      tap((result: any) => {
        this.notifyService.tellUser(result);
      })
    ));
  }

  async rowUpdating(e: any) {
    const key: number = e.key;
    const values: PromotionDetailsGroup = e.newData;
    if(e.oldData.product_type === 2) {
      this.swappingPromotionGroup = true;
      await confirm('This group contains Mix n Match products, are you sure you want to update all lines?', 'Update Promotion Group').then((result) => {
        if(result) {
          values.buying_group_id = this.header.buying_group_id;
          values.allowance_total = this.dataGrid.instance.cellValue(key, 'allowance_total');
          lastValueFrom(
            this.crudService.updateData(`${this.apiUrl}promotion-details-groups`, key, values).pipe(
              map((result: any) => {
                this.notifyService.tellUser(result);
              })
          ));
        } else {
          this.dataGrid.instance.cancelEditData();
        }
      this.swappingPromotionGroup = false;
      this.loadData();
      });
    } else {
      values.buying_group_id = this.header.buying_group_id;
      values.allowance_total = this.dataGrid.instance.cellValue(key, 'allowance_total');
      lastValueFrom(
        this.crudService.updateData(`${this.apiUrl}promotion-details-groups`, key, values).pipe(
          map((result: any) => {
            this.notifyService.tellUser(result);
          })
      ));
    }
  }

  updateCosts() {
    this.crudService.newGetData(`${this.apiUrl}update-costs?promotion_header_id=${this.header.id}&account_code=${this.header.account_code}`).subscribe((result:any) => {
      if(result.success) {
        this.loadData();
        this.notifyService.tellUser(result);
      }
    });
  }

  addColumn()
  {
    this.detailsLoading = true;
    const rebateNames$ = this.crudService.newGetData(`${this.apiUrl}rebates?type=0`).pipe(map((rebateNames: any) => { 
      return rebateNames.data.map((rebate: any) => {
        return rebate;
      });
    }));;
    this.columns = [];
    rebateNames$.subscribe((rebate: any) => {
      this.rebateNames = rebate;
      rebate.forEach((rebate: any) => {
        this.columns.push({
          dataField: rebate.rebate_name,
          dataType: 'number',
          visable: true,
          format: {
            type: 'currency',
            precision: 2
          },
          setCellValue: this.makeRebateSetter(rebate.rebate_name)
        });
      });
      this.detailsLoading = false;
      this.dataGrid.instance.state(this.loadState());
      this.isBuilt = true;
    });
  }

  onEditorPreparing(e: any) {
    if(e.parentType === "dataRow")
     e.editorOptions.onFocusIn = function (args: any) {
       args.element.querySelector("input.dx-texteditor-input").select();
     };
  }

  returnToPlanning = (e:any) =>{
    this.router.navigate(['/promotions']);
  }

  allowancePopupEvent(e: any)
  {
    //prevents sorting from happening while clicking button in header
    const nativeEvent = e.event || e;
    if (nativeEvent.stopPropagation) {
      nativeEvent.stopPropagation();
    }
      this.horizontalMenuService.seteditAllowances(true);
  }

  rebatePopupEvent(e: any)
  {
    const nativeEvent = e.event || e;
    if (nativeEvent.stopPropagation) {
      nativeEvent.stopPropagation();
    }
    this.horizontalMenuService.seteditPromotionRebates(true);
  }

  async swapPromotionGroup(e: any) {
    this.swappingPromotionGroup = true;
    e.key = e.promotion_details_groups_id;
    e.oldData = JSON.parse(localStorage.getItem('selectedPromotionGroup') || '');
    e.newData = e.promotion_groups[0];
    e.newData.sell_price = e.oldData.sell_price ? e.oldData.sell_price : e.newData.sell_price;
    e.newData.allowance = e.oldData.allowance ? e.oldData.allowance : e.newData.allowance;
    e.newData.allowance_group = e.oldData.allowance_group;
    if(e.oldData.comments) {
      e.newData.comments = e.oldData.comments;
    }
    e.newData.rebate = e.oldData.rebate || 0;
    e.newData.max_rebate_qty = e.oldData.max_rebate_qty ? Number(e.oldData.max_rebate_qty) : Number(e.newData.max_rebate_qty);
    if(e.oldData.rebate !== null) {
      this.rebateNames.forEach((rebate: RebateNames) => {
        e.newData[rebate.rebate_name] = e.oldData[rebate.rebate_name];
      });
    }
    await this.rowUpdating(e);
    this.dataGrid.instance.focus(e.key); // Focus on the updated row
    e.key = e.oldData.id; // Reset the key to the original key
    await this.rowRemoving(e);
    this.swappingPromotionGroup = false;
    this.loadData();
    localStorage.removeItem('selectedPromotionGroup');
  }

  // Each rebate column gets its own setter that closes over its dataField, so the
  // handler always knows which rebate it is writing — no shared global state, no
  // dependence on focus order or batch timing. newData.rebate is LOAD-BEARING: the
  // backend gate is array_key_exists('rebate', request) (PromotionDetailsGroupsController
  // ::update), so it must always be written or per-type propagation is skipped.
  private makeRebateSetter(rebateColumn: string) {
    return (newData: any, value: any, currentRowData: any) => {
      newData[rebateColumn] = value;
      // Recompute the aggregate from the merged view (pending edits in newData win over
      // stored values) so editing several rebate columns in one batch row stays correct.
      let total = 0;
      this.rebateNames.forEach((rebate: RebateNames) => {
        const v = (newData[rebate.rebate_name] !== undefined)
          ? newData[rebate.rebate_name]
          : currentRowData[rebate.rebate_name];
        total += (+v || 0);
      });
      newData.rebate = total;
    };
  }

  compareGroupTotals(row: PromotionDetailsGroup): number {
    if(row.pitem_count === row.pd_count) {
      return 0;
    }
    return 1
  }

  updateGroupCount(item: any) {
    this.dataGrid.instance.selectRowsByIndexes([(item.rowIndex - 1)]);
    const rowData: any = this.dataGrid.instance.getSelectedRowsData();
    rowData[0].pitem_count = 1;
    rowData[0].pd_count = 1;
    this.dataGrid.instance.cellValue(0, 'groupTotalColumn', rowData);
  }

  groupTotalData(e: any) {
    if(e.rowType === "data" && e.data.pitem_count !== e.data.pd_count && e.column.cellTemplate === 'cellTemplate') {
        on(e.cellElement, "mouseover", (arg: any) => {
          this.tooltipTarget = '#groupTotalColumn';
          this.tooltip.instance.show(arg.target);
          this.tooltipData = [`Promotion has: ${e.row.data.pd_count} of ${e.row.data.pitem_count} Promotion Group items`];
        });

        on(e.cellElement, "mouseout", (arg: any) => {
          this.tooltip.instance.hide();
        });
      }
  }

  detailEditMode = (e: any) => {
    this.masterDetailEditing = e; // Set to true if the detail grid is in edit mode
  }

  canDeactivate(): Promise<boolean> {
    if (this.dataGrid && this.dataGrid.instance.hasEditData() || this.masterDetailEditing) {
      return this.confirmationService.confirmUnsavedChangesNavigation();
    } else {
      return Promise.resolve(true);
    }

  }

  calculateAllowanceTotal(row: PromotionDetailsGroup) {
    const allowance_total = (+row.allowance_group || 0) + (+row.allowance_promotion || 0) + (+row.allowance || 0);
    return allowance_total;
  }

  setAllowanceTotal(newData: any, value: any, currentRowData: any): void
  {
    const total = (+currentRowData.allowance_group || 0) + (+currentRowData.allowance_promotion || 0) + (+value || 0);
    newData.allowance = value;
    newData.allowance_total = total;
  }

  setAllowance(newData: any, value: any, currentRowData: any): void
  {
    const amount = (+value || 0) - ((+currentRowData.allowance_group || 0) + (+currentRowData.allowance_promotion || 0));
    newData.allowance_total = value;
    newData.allowance = amount;
  }

  calculateGpAmount = (row: Product) =>
  {
    return this.costService.calculateGpAmount(row);
  }

  calculateGpPercent = (row: Product) =>
  {
    return this.costService.calculateGpPercent(row);
  }

  calculateNewCost = (row: Product) =>
  {
    return this.costService.calculateNewCost(row);
  }

  openPromotionGroupSelection = (e: any) => {
    if(e.row) {
      localStorage.setItem('selectedPromotionGroup', JSON.stringify(e.row.data));
    }
    this.promotionGroupSelection.instance.show();
  }

  closePromotionGroupSelection = (e: any) => {
    if(localStorage.getItem('selectedPromotionGroup') !== null) {
      this.swapPromotionGroup(e);
    }
    this.promotionGroupSelection.instance.hide();
  }
  calculateRebateCost = (row: Product) =>
  {
    return this.costService.calculateRebateCost(row);
  }

  calculateRebateDisplayCost = (row: Product) =>
  {
    return this.costService.calculateRebateDisplayCost(row);
  }

  calculateRebateGpAmount = (row: Product) =>
  {
    return this.costService.calculateRebateGpAmount(row);
  }

  calculateRebateGpPercent = (row: Product) =>
  {
    return this.costService.calculateRebateGpPercent(row);
  }

  customiseText = (cellInfo: any) =>
  {
    return cellInfo.valueText + '%';
  }

}
